var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._g({style:(_vm.__style),attrs:{"width":_vm.__width,"height":_vm.__height}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":`/assets/icon/${_vm.value}#${_vm.hash}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }